import React, { FC } from 'react';
import { Divider, Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';
import CustomNumberInput from '../../common/CustomNumberInput';
import { FinancesTotalProps } from './FinancesTotalProps';
const FinancesTotal: FC<FinancesTotalProps> = ({ currency, currencyRate }) => {
  const t = useTranslation();
  return (
    <Stack pb={5} spacing={3}>
      <Divider />
      <CustomNumberInput
        label={t('projects.properties.LandCG01')}
        currencySymbol={currency}
        name={'totalLand'}
        disabled
        currencyRate={currencyRate}
        dataTestID={'total-land'}
      />
      <CustomNumberInput
        label={t('projects.properties.propertyInvestmentBuilding')}
        currencySymbol={currency}
        name={'totalPropertyInv'}
        disabled
        currencyRate={currencyRate}
        dataTestID={'total-property-investments'}
      />
      <CustomNumberInput
        label={t('projects.properties.retailInvestmentCG1214')}
        currencySymbol={currency}
        name={'totalRetailInv'}
        disabled
        currencyRate={currencyRate}
        dataTestID={'total-retail-investments'}
      />

      <CustomNumberInput
        label={t('projects.properties.retailCostCG1516')}
        currencySymbol={currency}
        name={'totalRetail'}
        disabled
        currencyRate={currencyRate}
        dataTestID={'total-retail-cost'}
      />

      <Divider />
      <CustomNumberInput
        name={'totalProjectBudget'}
        currencySymbol={currency}
        label={t('finances.totalProjectBudget')}
        dataTestID={'total-project-budget'}
        disabled
        currencyRate={currencyRate}
      />
    </Stack>
  );
};

export default FinancesTotal;
